var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMeetingRoomCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.2222 44.4444H44.4444V5.55556C44.4444 4.02778 43.1944 2.77778 41.6667 2.77778H30.5556C30.5556 1.25 29.3056 0 27.7778 0H8.33333C6.80556 0 5.55556 1.25 5.55556 2.77778V44.4444H2.77778C1.25 44.4444 0 45.6944 0 47.2222C0 48.75 1.25 50 2.77778 50H27.7778C29.3056 50 30.5556 48.75 30.5556 47.2222V8.33333H38.8889V47.2222C38.8889 48.75 40.1389 50 41.6667 50H47.2222C48.75 50 50 48.75 50 47.2222C50 45.6944 48.75 44.4444 47.2222 44.4444ZM22.2222 27.7778C20.6944 27.7778 19.4444 26.5278 19.4444 25C19.4444 23.4722 20.6944 22.2222 22.2222 22.2222C23.75 22.2222 25 23.4722 25 25C25 26.5278 23.75 27.7778 22.2222 27.7778Z",
    fill: "#D75F04"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeetingRoomCard);
export default __webpack_public_path__ + "static/media/meeting-room-card.1b3b07f8c5310c752f91e181d47d03b8.svg";
export { ForwardRef as ReactComponent };